"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_transition_group_1 = require("react-transition-group");
var styled_components_1 = __importStar(require("styled-components"));
var Polished_1 = require("../utils/Polished");
var reactHelpers_1 = require("../utils/helpers/reactHelpers");
var Typography_1 = __importDefault(require("../Typography/Typography"));
var Link_1 = __importDefault(require("../Link"));
var ToastSC = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  box-sizing: border-box;\n  border-radius: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: ", ";\n\n  position: absolute;\n  left: 50%;\n  top: ", ";\n\n  z-index: ", ";\n\n  transform: translateX(-50%);\n\n  padding: ", ";\n\n  background-color: ", ";\n  box-shadow: ", "\n    ", ";\n\n  will-change: top;\n  transition: top 0.3s ease-in-out;\n\n  & svg {\n    margin-right: ", ";\n    flex: none;\n  }\n\n  & ._ndsToast__content {\n    max-width: ", ";\n    max-height: ", ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  & div a {\n    max-width: ", ";\n    max-height: ", ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-align: right;\n  }\n"], ["\n  width: ", ";\n  box-sizing: border-box;\n  border-radius: ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: ", ";\n\n  position: absolute;\n  left: 50%;\n  top: ", ";\n\n  z-index: ", ";\n\n  transform: translateX(-50%);\n\n  padding: ", ";\n\n  background-color: ", ";\n  box-shadow: ", "\n    ", ";\n\n  will-change: top;\n  transition: top 0.3s ease-in-out;\n\n  & svg {\n    margin-right: ", ";\n    flex: none;\n  }\n\n  & ._ndsToast__content {\n    max-width: ", ";\n    max-height: ", ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  & div a {\n    max-width: ", ";\n    max-height: ", ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-align: right;\n  }\n"])), function (p) { return p.theme.SizeWidthToastBase; }, function (p) { return p.theme.SizeBorderRadiusToastBase; }, function (p) { return (p.inline ? 'unset' : 'wrap'); }, Polished_1.rem('16px'), function (p) { return p.theme.zIndex.topLayer; }, function (p) { return p.theme.SizePaddingToastBase; }, function (p) { return p.theme.ColorBackgroundGreyDark2; }, function (p) { return p.theme.SizeShadowToastBase; }, function (p) { return p.theme.ColorShadowToastBase; }, Polished_1.rem('8px'), Polished_1.rem('272px'), Polished_1.rem('40px'), Polished_1.rem('304px'), Polished_1.rem('20px'));
var Toast = (function (_super) {
    __extends(Toast, _super);
    function Toast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isIn: false
        };
        _this.startDismissTimer = function () {
            clearTimeout(_this.dismissTimer);
            _this.dismissTimer = setTimeout(function () {
                return _this.setState({
                    isIn: false
                });
            }, 4000);
        };
        _this.onEntered = function () {
            _this.startDismissTimer();
        };
        _this.clickAction = function (event) {
            var onAction = _this.props.onAction;
            if (onAction !== undefined) {
                onAction(event);
            }
        };
        return _this;
    }
    Toast.prototype.componentDidMount = function () {
        var _this = this;
        this.delayedStartTimer = setTimeout(function () {
            _this.setState({ isIn: true });
        }, 300);
    };
    Toast.prototype.componentDidUpdate = function (_prevProps, prevState) {
        var isIn = this.state.isIn;
        if (prevState.isIn && isIn) {
            this.startDismissTimer();
        }
    };
    Toast.prototype.componentWillUnmount = function () {
        clearTimeout(this.delayedStartTimer);
    };
    Toast.prototype.render = function () {
        var _a = this.props, message = _a.message, action = _a.action, inline = _a.inline, icon = _a.icon, type = _a.type, theme = _a.theme, onAction = _a.onAction, forwardedRef = _a.forwardedRef, others = __rest(_a, ["message", "action", "inline", "icon", "type", "theme", "onAction", "forwardedRef"]);
        var isIn = this.state.isIn;
        var clickAction = this.clickAction;
        var renderText = (react_1.default.createElement(Typography_1.default, { mode: "dark", variant: "body3", className: "_ndsToast__content" }, message));
        var contentRow = null;
        if (icon) {
            var iconColor = {
                success: '#3fc078',
                alert: '#f43e6d',
                info: '#a3c2f5'
            };
            var iconComp = null;
            if (react_1.default.isValidElement(icon)) {
                iconComp = react_1.default.cloneElement(icon, {
                    color: iconColor[type]
                });
            }
            contentRow = (react_1.default.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center'
                } },
                iconComp,
                renderText));
        }
        else {
            contentRow = renderText;
        }
        var renderAction = action ? (react_1.default.createElement(Link_1.default, { mode: "dark", onClick: clickAction }, action)) : null;
        var actionRow = inline ? (renderAction) : (react_1.default.createElement("div", { style: {
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: Polished_1.rem('8px')
            } }, renderAction));
        var defaultStyle = {
            willChange: 'top',
            transition: "top 0.3s ease-in-out",
            position: 'fixed',
            top: Polished_1.rem('-120px'),
            left: '50%',
            zIndex: theme.zIndex.topLayer
        };
        var transitionStyles = {
            entering: { top: '0' },
            entered: { top: '0' },
            exiting: { top: Polished_1.rem('-120px') },
            exited: { top: Polished_1.rem('-120px') }
        };
        return (react_1.default.createElement(react_transition_group_1.Transition, { in: isIn, timeout: 300, onEntered: this.onEntered }, function (state) { return (react_1.default.createElement("div", __assign({ ref: forwardedRef, style: __assign(__assign({}, defaultStyle), transitionStyles[state]) }, others),
            react_1.default.createElement(ToastSC, { inline: inline },
                contentRow,
                actionRow))); }));
    };
    Toast.propTypes = {
        message: prop_types_1.default.string.isRequired,
        action: prop_types_1.default.string,
        onAction: prop_types_1.default.func,
        inline: prop_types_1.default.bool,
        type: prop_types_1.default.oneOf(['success', 'alert', 'info']),
        icon: prop_types_1.default.element,
        forwardedRef: prop_types_1.default.any
    };
    Toast.defaultProps = {
        action: null,
        onAction: null,
        inline: false,
        icon: null,
        type: 'success',
        forwardedRef: null
    };
    return Toast;
}(react_1.default.Component));
exports.ToastRootComp = Toast;
var ToastWithTheme = styled_components_1.withTheme(Toast);
ToastWithTheme.displayName = 'Toast';
exports.default = reactHelpers_1.withForwardedRef(ToastWithTheme);
var templateObject_1;
//# sourceMappingURL=Toast.js.map